export const useFormValidation = () => {
  const validateEmailFormat = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email === "") {
      return true;
    }
    return emailRegex.test(email);
  };

  const validateTemplateBodyLength = (body: string): boolean => {
    return body.length < 65365;
  };

  return { validateEmailFormat, validateTemplateBodyLength };
};
